import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { BRAND, FOUNDER } from '../../data/mock';

import { img } from '../../lib/img';

export default function FinalCTA() {
  return (
    <section className="relative py-32 lg:py-48 bg-charcoal-deep text-ivory overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage: `url(${img(FOUNDER.image, 1400)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center 20%',
          filter: 'grayscale(0.3)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal-deep via-charcoal-deep/85 to-charcoal-deep/70" />

      <div className="relative max-w-[1100px] mx-auto px-5 md:px-10 text-center reveal">
        <p className="text-[11px] tracking-[0.3em] uppercase text-champagne mb-8">An Invitation</p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[1.05]">
          The best-dressed man in the room <br className="hidden md:block"/>
          isn’t always <em className="italic-accent">the richest.</em>
        </h2>
        <p className="mt-8 font-display text-2xl lg:text-3xl text-champagne tracking-wide">
          He’s the most intentional.
        </p>

        <div className="mt-14 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/book-consultation">
            <Button className="group bg-champagne hover:bg-champagne-light text-charcoal-deep rounded-none px-10 py-7 text-[11px] tracking-[0.22em] uppercase">
              Book Your Private Consultation
              <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <a
            href={`https://wa.me/${BRAND.phoneRaw}?text=Hello%2C%20I%27d%20like%20to%20book%20a%20private%20styling%20consultation.`}
            target="_blank"
            rel="noreferrer"
          >
            <Button variant="outline" className="border-ivory/30 text-ivory hover:bg-ivory hover:text-charcoal rounded-none px-10 py-7 text-[11px] tracking-[0.22em] uppercase bg-transparent">
              WhatsApp Now
            </Button>
          </a>
        </div>

        <p className="mt-10 text-xs text-ivory/40 tracking-wider">
          By appointment · HSR, Bengaluru · {BRAND.phone}
        </p>
      </div>
    </section>
  );
}
